import { useCallback, useState } from "react";

/**
 * Tracks the pitches this browser session has successfully sent, so the HUD can
 * show a live count, the last pitch, and a short recent list. This is the
 * tool's own knowledge (instant, local) — the authoritative game total comes
 * later from the game-state API (Task 8).
 */
export const usePitchLog = (maxRecent = 5) => {
  const [entries, setEntries] = useState([]);
  const record = useCallback(
    (payload) => setEntries((prev) => [...prev, payload]),
    []
  );
  return {
    entries,
    record,
    count: entries.length,
    last: entries.length ? entries[entries.length - 1] : null,
    recent: entries.slice(-maxRecent).reverse(), // newest first
  };
};
